import _ from 'lodash';

export default function (service) {
  service.contract = [
    { text: 'Прямая аренда', value: 1 },
    { text: 'Субаренда', value: 2 },
    { text: 'Договор совм. деят.', value: 5 },
    { text: 'Продажа объекта', value: 4 },
    { text: 'Переуступка прав аренды', value: 3 },
  ];

  service.contract_rent = _.filter(service.contract,
    item => _.includes([1, 2], item.value)
  );

  service.contract_sale = _.filter(service.contract,
    item => _.includes([3, 4], item.value)
  );

  // deprecated
  service.building_type = [
    { value: 1, text: 'Бизнес-центр' },
    { value: 3, text: 'Нежилое' },
    { value: 4, text: 'Жилое' },
    { value: 2, text: 'ТРЦ' },
    { value: 5, text: 'Старый фонд' },
  ];

  service.building_type__building = [
    { value: 40, text: 'Свободное' },
    { value: 37, text: 'Имущественный комплекс' },
    { value: 6, text: 'Офисное' },
    { value: 41, text: 'Офисно-складское' },
    { value: 2, text: 'Торгово-развлекательный центр' },
    { value: 14, text: 'Административное' },
    { value: 1, text: 'Бизнес-центр' },
    { value: 38, text: 'Производственное' },
    { value: 39, text: 'Модульное' },
  ];

  service.building_type2 = [
    { value: 14, text: 'Административное здание' },
    { value: 32, text: 'Аутлет' },
    { value: 25, text: 'Бизнес-квартал' },
    { value: 7, text: 'Бизнес-парк' },
    { value: 1, text: 'Бизнес-центр' },
    { value: 22, text: 'Деловой центр' },
    { value: 15, text: 'Индустриальный парк' },
    { value: 16, text: 'Логистический комплекс' },
    { value: 12, text: 'Логистический центр' },
    { value: 18, text: 'Многофункциональный комплекс' },
    { value: 36, text: 'Объект свободного назначения' },
    { value: 23, text: 'Особняк' },
    { value: 26, text: 'Отдельно стоящее здание' },
    { value: 21, text: 'Офисно-гостиничный комплекс' },
    { value: 19, text: 'Офисно-жилой комплекс' },
    { value: 8, text: 'Офисно-производственный комплекс' },
    { value: 9, text: 'Офисно-складской комплекс' },
    { value: 6, text: 'Офисное здание' },
    { value: 11, text: 'Производственно-складской комплекс' },
    { value: 33, text: 'Производственный комплекс' },
    { value: 35, text: 'Производственный цех' },
    { value: 34, text: 'Промплощадка' },
    { value: 13, text: 'Склад' },
    { value: 10, text: 'Складской комплекс' },
    { value: 30, text: 'Специализированный торговый центр' },
    { value: 24, text: 'Технопарк' },
    { value: 17, text: 'Торгово-деловой комплекс' },
    { value: 31, text: 'Торгово-общественный центр' },
    { value: 20, text: 'Торгово-офисный комплекс' },
    { value: 2, text: 'Торгово-развлекательный центр' },
    { value: 29, text: 'Торговый центр' },

    { value: 27, text: 'Жилой дом' },
    { value: 28, text: 'Жилой комплекс' },
    { value: 5, text: 'Старый фонд' },

    { value: 100, text: 'Другое' },
  ];

  service.property_type = [
    { value: 1, text: 'Офис' },
    { value: 2, text: 'Склад' },
    { value: 3, text: 'Торговая площадь' },
    { value: 4, text: 'Производство' },
    { value: 5, text: 'Здание' },
    { value: 6, text: 'Помещение свободного назначения' },
    { value: 7, text: 'Земля' },
    { value: 8, text: 'Гараж' },
  ];

  // deprecated
  service.house_class = [
    { value: 1, text: 'A' },
    { value: 2, text: 'A+' },
    { value: 3, text: 'B' },
    { value: 4, text: 'B+' },
    { value: 5, text: 'C' },
    { value: 6, text: 'C+' },
  ];

  service.building_class_type = [
    { value: 2, text: 'A+' },
    { value: 1, text: 'A' },
    { value: 4, text: 'B+' },
    { value: 3, text: 'B' },
    { value: 8, text: 'B-' },
    { value: 5, text: 'C' },
  ];

  service.building_class_type__warehouse = [
    { value: 1, text: 'A' },
    { value: 3, text: 'B' },
    { value: 5, text: 'C' },
    { value: 7, text: 'D' },
  ];

  service.from_offrep = [
    { value: true, text: 'От оф. представителей' },
    { value: false, text: 'От агентов' },
  ];

  service.building_lift_types_type = [
    { value: 1, text: 'Грузовой', tag: 'Грузовой лифт' },
    { value: 2, text: 'Тельфер' },
    { value: 3, text: 'Пассажирский', tag: 'Пассажирский лифт' },
  ];

  service.building_cranage_types_type = [
    { value: 1, text: 'Мостовой кран' },
    { value: 2, text: 'Кран-балка' },
    { value: 3, text: 'Ж/д кран' },
    { value: 4, text: 'Козловой кран' },
  ];

  service.building_gates_type = [
    { value: 1, text: 'На пандусе', tag: 'Ворота на пандусе' },
    { value: 2, text: 'Докового типа', tag: 'Ворота докового типа' },
    { value: 3, text: 'На нулевой отметке', tag: 'Ворота на нулевой отметке' },
  ];

  service.building_heating_type = [
    { value: 3, text: 'Автономное', tag: 'Автономное отопление' },
    { value: 2, text: 'Центральное', tag: 'Центральное отопление' },
    { value: 1, text: 'Нет', tag: 'Без отопления' },
  ];

  service.estate_type = [
    { value: 2, text: 'В аренде', tag: 'Недвижимость в аренде' },
    { value: 1, text: 'В собственности', tag: 'Недвижимость в собственности' },
  ];

  service.has_equipment = [
    { value: true, text: 'С оборудованием' },
    { value: false, text: 'Без оборудования' },
  ];


  // Состояние

  service.condition_type = [
    { value: 1, text: 'Офисная отделка' },
    { value: 2, text: 'Под чистовую отделку' },
    { value: 3, text: 'Требуется капитальный ремонт' },
    { value: 4, text: 'Требуется косметический ремонт' },
  ];

  service.condition_type__free_appointment_object = [
    { value: 5, text: 'Типовой ремонт' },
    { value: 6, text: 'Дизайнерский ремонт' },
    { value: 2, text: 'Под чистовую отделку' },
    { value: 3, text: 'Требуется капитальный ремонт' },
    { value: 4, text: 'Требуется косметический ремонт' },
  ];

  service.condition_type__industry = [
    { value: 5, text: 'Типовой ремонт' },
    { value: 3, text: 'Требуется капитальный ремонт' },
    { value: 4, text: 'Требуется косметический ремонт' },
  ];


  // Инфраструктура

  const industryInfrastructure = [
    'infrastructure_has_buffet',
    'infrastructure_has_hotel',
    'infrastructure_has_canteen',
    'infrastructure_has_office_space',
    'infrastructure_has_central_reception',
  ];

  /** @memberOf FilterTermsService */
  service.infrastructure = {
    all: {
      infrastructure_has_slot_machines: 'игровые автоматы',
      infrastructure_has_notary_office: 'нотариальная контора',
      infrastructure_has_hotel: 'гостиница',
      infrastructure_has_office_space: 'офисные помещения',
      infrastructure_has_atm: 'банкомат',
      infrastructure_has_aquapark: 'аквапарк',
      infrastructure_has_cafe: 'кафе',
      infrastructure_has_clothes_studio: 'ателье одежды',
      infrastructure_has_basement: 'подвал/погреб',
      infrastructure_has_tire: 'шиномонтаж',
      infrastructure_has_fitness_centre: 'фитнес-центр',
      infrastructure_has_shopping_area: 'торговая зона',
      infrastructure_has_pool: 'бассейн',
      infrastructure_has_cinema: 'кинотеатр',
      infrastructure_has_car_wash: 'автомойка',
      infrastructure_has_food_court: 'фуд-корт',
      infrastructure_has_medical_center: 'медицинский центр',
      infrastructure_has_restaurant: 'ресторан',
      infrastructure_has_video_surveillance: 'видеонаблюдение',
      infrastructure_has_minimarket: 'минимаркет',
      infrastructure_has_beauty_shop: 'салон красоты',
      infrastructure_has_warehouse: 'складские помещения',
      infrastructure_has_bowling: 'боулинг',
      infrastructure_has_baby_sitting: 'беби-ситинг',
      infrastructure_has_canteen: 'столовая',
      infrastructure_has_pharmacy: 'аптека',
      infrastructure_has_supermarket: 'супермаркет',
      infrastructure_has_buffet: 'буфет',
      infrastructure_has_conference_room: 'конференц-зал',
      infrastructure_has_inspection_pit: 'смотровая яма',
      infrastructure_has_park: 'парк',
      infrastructure_has_rink: 'каток',
      infrastructure_has_hour_security: 'круглосуточная охрана',
      infrastructure_has_game_room: 'игровая комната',
      infrastructure_has_exhibition_and_warehouse_complex: 'выставочно-складской комплекс',
      infrastructure_has_bank_department: 'отделение банка',
      infrastructure_has_automatic_gates: 'автоматические ворота',
      infrastructure_has_central_reception: 'центральная рецепция',
      infrastructure_has_entry_by_pass: 'въезд по пропускам',
      infrastructure_has_car_service: 'автосервис',
      infrastructure_has_studio: 'фотосалон',
    },
    office: [
      'infrastructure_has_car_wash',
      'infrastructure_has_car_service',
      'infrastructure_has_pharmacy',
      'infrastructure_has_clothes_studio',
      'infrastructure_has_atm',
      'infrastructure_has_pool',
      'infrastructure_has_buffet',
      'infrastructure_has_exhibition_and_warehouse_complex',
      'infrastructure_has_hotel',
      'infrastructure_has_cafe',
      'infrastructure_has_cinema',
      'infrastructure_has_conference_room',
      'infrastructure_has_medical_center',
      'infrastructure_has_minimarket',
      'infrastructure_has_notary_office',
      'infrastructure_has_bank_department',
      'infrastructure_has_park',
      'infrastructure_has_restaurant',
      'infrastructure_has_beauty_shop',
      'infrastructure_has_warehouse',
      'infrastructure_has_canteen',
      'infrastructure_has_supermarket',
      'infrastructure_has_shopping_area',
      'infrastructure_has_fitness_centre',
      'infrastructure_has_studio',
      'infrastructure_has_central_reception',
    ],
    shoppingArea: [
      'infrastructure_has_car_wash',
      'infrastructure_has_car_service',
      'infrastructure_has_aquapark',
      'infrastructure_has_pharmacy',
      'infrastructure_has_clothes_studio',
      'infrastructure_has_atm',
      'infrastructure_has_pool',
      'infrastructure_has_baby_sitting',
      'infrastructure_has_bowling',
      'infrastructure_has_buffet',
      'infrastructure_has_hotel',
      'infrastructure_has_game_room',
      'infrastructure_has_slot_machines',
      'infrastructure_has_rink',
      'infrastructure_has_cafe',
      'infrastructure_has_cinema',
      'infrastructure_has_medical_center',
      'infrastructure_has_minimarket',
      'infrastructure_has_bank_department',
      'infrastructure_has_restaurant',
      'infrastructure_has_beauty_shop',
      'infrastructure_has_warehouse',
      'infrastructure_has_canteen',
      'infrastructure_has_supermarket',
      'infrastructure_has_fitness_centre',
      'infrastructure_has_studio',
      'infrastructure_has_food_court',
      'infrastructure_has_central_reception',
    ],
    industry: industryInfrastructure,
    warehouse: industryInfrastructure,
  };

  _.each(service.infrastructure.all, (text, propName) => {
    service[propName] = [
      { value: true, text: _.capitalize(text), tag: `Есть ${text}` },
    ];
  });

  /**
   * Возвращает общие фильтры инфраструктуры для списка объектов
   * Если у одного из объектов нет инфраструктуры, то результат будет пустой
   * @memberOf FilterTermsService
   * @param {string[]} objectNames
   * @return {string[]}
   */
  service.getInfrastructureFor = objectNames => _.union(
    ..._.map(objectNames, name => (service.infrastructure[name] || []))
  );


  service.placement_type = [
    { value: 2, text: 'Street retail' },
    { value: 1, text: 'В торговом комплексе', tag: 'Помещение в торговом комплексе' },
  ];

  service.building_house_line_type = [
    { value: 1, text: 'Первая', tag: 'Первая линия домов' },
    { value: 2, text: 'Вторая', tag: 'Вторая линия домов' },
  ];
  service.building_house_line_type__shopping_area = service.building_house_line_type;

  service.input_type = [
    { value: 4, text: 'Общий с улицы', tag: 'Общий вход с улицы' },
    { value: 3, text: 'Общий со двора', tag: 'Общий вход со двора' },
    { value: 2, text: 'Отдельный с улицы', tag: 'Отдельный вход с улицы' },
    { value: 1, text: 'Отдельный со двора', tag: 'Отдельный вход со двора' },
  ];


  // Гараж

  service.garage_type = [
    { value: 2, text: 'Гараж' },
    { value: 1, text: 'Машиноместо' },
    { value: 3, text: 'Бокс' },
  ];

  service.garage_garage_type = [
    { value: 1, text: 'Встроенный' },
    { value: 2, text: 'Капитальный' },
    { value: 3, text: 'Ракушка' },
    { value: 4, text: 'Самострой' },
  ];

  service.garage_material = [
    { value: 2, text: 'Кирпичный' },
    { value: 1, text: 'Металлический' },
  ];

  service.garage_status = [
    { value: 2, text: 'Собственность' },
    { value: 1, text: 'Кооператив' },
    { value: 3, text: 'По доверенности' },
  ];

  service.has_light = [
    { value: true, text: 'Есть свет' },
  ];

  service.has_electricity = [
    { value: true, text: 'Есть электричество' },
  ];

  service.has_heating = [
    { value: true, text: 'Есть отопление' },
  ];

  service.has_extinguishing_system = [
    { value: true, text: 'Есть система пожаротушения' },
  ];


}



// WEBPACK FOOTER //
// ./src/components/filter/src/scripts/filter-terms/commercial.js